import { render, staticRenderFns } from "./EthGasLineChart.vue?vue&type=template&id=5a51d841&scoped=true&"
import script from "./EthGasLineChart.vue?vue&type=script&lang=js&"
export * from "./EthGasLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51d841",
  null
  
)

export default component.exports